<div class="app-shell">
  <app-navbar></app-navbar>
  <main class="public-main">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
